<template>
  <el-row
    class="bind-wrapper"
    v-loading="pageLoading"
  >
    <div class="acConnect">
      <app-logo
        v-if="appProfile.name"
        style="margin-bottom: 2rem;"
        :app-name="appProfile.name ? appProfile.name.toLocaleLowerCase() : ''"
        :singLogo="true"
      >
        <span class="ml-4 acConnect__title">{{ appProfile.name }}</span>
      </app-logo>
      <div class="acConnect__text">
        <span
          v-if="!needReLogin"
          class="acConnect__text-title"
        >
          {{ $t('thirdPartyLogin.codeHasBeenSentTo') }} {{ params.tel }}
        </span>
        <p class="acConnect__text-descr">
          <el-input
            ref="inputRef"
            v-model="smsCode"
            :maxlength="4"
            :disabled="needReLogin"
            autofocus
            clearable
            :placeholder="$t('thirdPartyLogin.enterVerifyCode')"
            @keyup.enter.native="verifySmsCode"
          >
            <el-button
              slot="append"
              :disabled="!!time || needReLogin"
              @click="getCode()"
            >
              {{ time ? $t('thirdPartyLogin.getCodeAgain') : $t('thirdPartyLogin.getCode') }}
              <span v-if="time">({{ time }})</span>
            </el-button>
          </el-input>
        </p>
      </div>
      <div class="acConnect__btns">
        <el-button
          v-if="needReLogin"
          class="acConnect__btns-item"
          size="medium"
          type="warning"
          @click="toReturnUrl"
        >
          {{ $t('thirdPartyLogin.needRelogin') }}
        </el-button>
        <el-button
          v-else
          class="acConnect__btns-item"
          size="medium"
          type="primary"
          :disabled="!smsCode || smsCode.length < 4 || confirming"
          @click="verifySmsCode"
        >
          {{ $t('common.login') }}
        </el-button>
      </div>
    </div>
  </el-row>
</template>

<script>
import axios from 'axios';
import AppLogo from '../components/AppLogo';

export default {
  name: 'SmsLogin',
  components: {
    AppLogo,
  },
  data() {
    return {
      pageLoading: true,

      // 接收短信的电话号码
      tel: '',
      smsCode: '',
      appProfile: {},
      logo: '',
      urls: {
        home_url: process.env.HAMLET_URL || 'https://hamlet.flywheeldigital.com.cn',
        appProfile: '/api/auth/apps/profile',
        verifySmsCode: '/api/auth/sms/verify/sms_code',
        sendSmsCode: '/api/auth/sms/send_sms',
      },
      time: 60,
      timer: null,
      confirming: false,
      needReLogin: false,
      tokens: {},
      params: {
        app_key: '',
        sms_type: 'login',
        lang: 'en',
        tel: '',
      },
    };
  },
  computed: {
    headers() {
      const { query } = this.$route;
      const token = query.tk || query.hamlet_tk;
      if (token) {
        return {
          Authorization: token.startsWith('Bearer ') ? token : `Bearer ${token}`,
        };
      }

      return {};
    },
  },
  created() {
    const { query } = this.$route;
    if (!query.ak || !query.sk) {
      this.pageLoading = false;
      this.toReturnUrl();
    }

    this.params.tel = query.tel || '';
    this.params.app_key = query.ak;
    this.params.sms_token = query.sk;
    this.getAppProfile();

    if (query.lang) {
      this.params.lang = query.lang;
      if (this.$locale) {
        this.$locale.use(query.lang === 'en' ? 'en' : 'zh');
      }
    }

    this.initialTime();
  },
  beforeRouteLeave() {
    clearInterval(this.timer);
  },
  beforeDestroy() {
    clearInterval(this.timer);
  },
  methods: {
    initialTime() {
      this.time = 60;
    },
    getAppProfile() {
      this.pageLoading = true;
      this.httpAxios(this.urls.appProfile, {
        app_key: this.params.app_key,
      }, 'GET', this.headers)
        .then((val) => {
          this.appProfile = val.data || {};
          this.countDown();
        })
        .catch((err) => {
          console.log('>>>>err\n', err);
          if (err.status === 401) {
            this.toReturnUrl();
          }
        })
        .finally(() => {
          setTimeout(() => {
            this.pageLoading = false;
          }, 600);
        });
    },
    httpAxios(url, data, method = 'GET', headers = {}) {
      let params = { method, url };

      if (method === 'GET') {
        params = Object.assign(params, { params: data });
      } else {
        params.data = data;
      }

      if (headers) {
        params = Object.assign(params, { headers });
      }

      // console.log('>>>>>>params', params);
      return axios(params)
        .then((res) => {
          if (res.data.ok) {
            return res.data;
          }

          return Promise.reject(res.data);
        })
        .catch((err) => {
          console.error('>>>http>>>err>>>\n', err);
          return Promise.reject(err.response || err);
        });
    },
    getCode() {
      this.httpAxios(this.urls.sendSmsCode, {
        app_key: this.params.app_key,
        sms_token: this.params.sms_token,
        lang: this.params.lang,
      }, 'POST')
        .then((val) => {
          const { data } = val;
          // console.log('>>>sendSmsCode>>>val>>>>', val);
          this.params.sms_token = data.sms_token;
          this.initialTime();
          this.countDown();
        })
        .catch((err) => {
          // console.log('>>>>sendSmsCode>>>err', err);
          const { err_code: errCode } = err;
          let reason = err.reason;

          if (errCode === '01C0705') {
            this.needReLogin = true;
          } else if (errCode === '01C0706') {
            const { data } = err;
            const message = data.sms_message ? data.sms_message.message : this.$t('common.contactAdmin');
            reason = `${reason}: ${message}`;
          }

          this.$message.error(reason);
        });
    },
    countDown() {
      this.timer = setInterval(() => {
        this.time -= 1;
        if (this.time <= 0) {
          clearInterval(this.timer);
        }
      }, 1000);
    },
    verifySmsCode() {
      this.confirming = true;
      const params = {
        app_key: this.params.app_key,
        sms_token: this.params.sms_token,
        sms_code: this.smsCode,
        lang: this.params.lang,
      };
      this.httpAxios(this.urls.verifySmsCode, params, 'POST')
        .then((val) => {
          const { data } = val;

          // 验证码正确
          if (data.access_token) {
            this.tokens = data;
            this.enterApp();
          }
        })
        .catch((err) => {
          console.log('>>>>verifySmsCode>>>err', err);
          const { reason } = err;
          this.$message.error(reason);
        })
        .finally(() => {
          this.confirming = false;
        });
    },
    enterApp() {
      clearInterval(this.timer);
      const { query } = this.$route;
      const { tokens } = this;
      window.location = `${query.ru}?thirdparty_connect_access_token=${tokens.access_token}&thirdparty_connect_refresh_token=${tokens.refresh_token}`;
    },
    toReturnUrl() {
      const { query } = this.$route;
      window.location = query.ru || query.a_ru || query.hamlet_a_ru || this.urls.home_url;
    },
  },
};
</script>



// WEBPACK FOOTER //
// SmsLogin.vue?6ca79424